import { formatNumberUSD } from "util/format"

import { HStack, Spacer, Text } from "@chakra-ui/react"
import { MotionVStack, MotionVStackProps } from "component/Motion"
import { Stats } from "component/Stats"
import { useTranslation } from "react-i18next"
import { CreateLimitOrder } from "sdk-react/limitOrder/useCreateLimitOrder"

import { CreateOrder } from "../../hook/useCreateOrder"
import { usePositionDraftDetailStrings } from "../../hook/usePositionDraftDetailStrings"

const PLACEHOLDER = "-,---"

interface TradingSummaryProps extends MotionVStackProps {}

export function TradingSummary(props: TradingSummaryProps) {
    const { isOrderTypeLimit, isOrderTypeStop } = CreateOrder.useContainer()

    return isOrderTypeLimit || isOrderTypeStop ? (
        <TradingSummaryLimitOrder {...props} />
    ) : (
        <TradingSummaryMarketOrder {...props} />
    )
}

function TradingSummaryLimitOrder({ ...motionVStackProps }: TradingSummaryProps) {
    const { transactionFee, limitPrice } = CreateLimitOrder.useContainer()
    const { t } = useTranslation()
    const entryPriceStr = limitPrice ? formatNumberUSD({ num: limitPrice }) : PLACEHOLDER
    const transactionFeeStr = transactionFee ? `${formatNumberUSD({ num: transactionFee })}` : PLACEHOLDER

    return (
        <MotionVStack spacing={2} align="stretch" w="100%" {...motionVStackProps}>
            <HStack>
                <Text variant="label">Summary</Text>
                <Spacer />
            </HStack>
            <Stats size="xs" variant="left" label={t("position.entry_price")} number={entryPriceStr} />
            <Stats
                size="xs"
                variant="left"
                label={t("general.transaction_fee")}
                number={transactionFeeStr}
                icon={<>≈</>}
            />
        </MotionVStack>
    )
}

function TradingSummaryMarketOrder({ ...motionVStackProps }: TradingSummaryProps) {
    const { t } = useTranslation()
    const { priceImpactStr, entryPriceStr, transactionFeeStr } = usePositionDraftDetailStrings()

    return (
        <MotionVStack spacing={2} align="stretch" w="100%" {...motionVStackProps}>
            <HStack>
                <Text variant="label">Summary</Text>
                <Spacer />
            </HStack>
            <Stats size="xs" variant="left" label={t("position.entry_price")} number={entryPriceStr} />

            {/* TODO: add this when contract supports this calculation
            <Stats
               size="xs"
               variant="left"
               label={t("position.liquidation_price")}
               number={nextLiquidationPriceStr}
            /> */}
            <Stats size="xs" variant="left" label={t("general.transaction_fee")} number={transactionFeeStr} />
            <Stats size="xs" variant="left" label={t("position.price_impact")} number={priceImpactStr} />

            {/* TODO: calculate exactly how much is our gas rebate from  https://rewards-staging.perp.com/gas-rebate (Norman, Davis)  */}
            {/* {gasRebateNote && (
                <ExternalLink href={gasRebateNote.ctaLink as string}>
                    <Stats size="xs" variant="left" label={"Gas Fee"} number={"0 - Gas Rebate Program ↗"} />
                </ExternalLink>
            )} */}

            {/* TODO: add back later
            <MotionVStack spacing={2} animate={{ opacity: showMore ? 1 : 0, height: showMore ? "auto" : 0 }}>
                <Stats
                    size="xs"
                    variant="left"
                    label={t("vault.free_collateral")}
                    number={`${freeCollateralStr} → ${nextFreeCollateralStr}`}
                />
                <Stats
                    size="xs"
                    variant="left"
                    label={t("vault.margin_ratio")}
                    number={`${marginRatioStr} → ${nextMarginRatioStr}`}
                />
                <Stats
                    size="xs"
                    variant="left"
                    label={t("vault.account_leverage")}
                    number={`${leverageStr} → ${nextLeverageStr}`}
                />
            </MotionVStack> */}
        </MotionVStack>
    )
}
